import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { CounterpartyAddress } from "@common/schemas/counterpartyAddress.schema";
import { CounterpartyContact } from "@common/schemas/counterpartyContact.schema";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Tag } from "@design-system/Tag/Tag";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

const PrimaryCell = ({ isPrimary }: { isPrimary: boolean }) => (
    <ViewTableCell>
        {isPrimary ? (
            <Tag color="neutral" size="sm">
                Primary
            </Tag>
        ) : null}
    </ViewTableCell>
);

export const CounterpartyContactPrimaryCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CounterpartyContact, boolean>) => (
        <PrimaryCell isPrimary={row.original.isPrimary} />
    ),
);

export const CounterpartyAddressPrimaryCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CounterpartyAddress, boolean>) => (
        <PrimaryCell isPrimary={row.original.isPrimary} />
    ),
);

CounterpartyContactPrimaryCell.displayName = "CounterpartyContactPrimaryCell";
CounterpartyAddressPrimaryCell.displayName = "CounterpartyAddressPrimaryCell";
